function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userListApi, groupListApi, levelListApi, tagListApi, groupPiApi, tagPiApi, foundsApi, updateSpreadApi, updatePhoneApi, integralBatchClearApi, userLogoffApi } from '@/api/user';
import { spreadClearApi } from '@/api/distribution';
import editFrom from './edit';
import userDetails from './userDetails';
import levelEdit from './level';
import userList from '@/components/userList';
import * as logistics from '@/api/logistics.js';
import Cookies from 'js-cookie';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { Debounce } from '@/utils/validate';
export default {
  name: 'UserIndex',
  components: {
    editFrom: editFrom,
    userDetails: userDetails,
    userList: userList,
    levelEdit: levelEdit
  },
  filters: {
    sexFilter: function sexFilter(status) {
      var statusMap = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return statusMap[status];
    }
  },
  data: function data() {
    return {
      formExtension: {
        image: '',
        spreadUid: '',
        userId: ''
      },
      ruleInline: {},
      extensionVisible: false,
      userVisible: false,
      levelInfo: '',
      pickerOptions: this.$timeOptions,
      loadingBtn: false,
      PointValidateForm: {
        integralType: 2,
        integralValue: 0,
        moneyType: 2,
        moneyValue: 0,
        uid: ''
      },
      loadingPoint: false,
      VisiblePoint: false,
      visible: false,
      userIds: '',
      dialogVisible: false,
      levelVisible: false,
      levelData: [],
      groupData: [],
      labelData: [],
      selData: [],
      labelPosition: 'right',
      collapse: false,
      props: {
        children: 'child',
        label: 'name',
        value: 'name',
        emitPath: false
      },
      propsCity: {
        children: 'child',
        label: 'name',
        value: 'name'
      },
      headeNum: [{
        type: '',
        name: '全部用户'
      }, {
        type: 'wechat',
        name: '微信公众号用户'
      }, {
        type: 'routine',
        name: '微信小程序用户'
      }, {
        type: 'h5',
        name: 'H5用户'
      }],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      loginType: '0',
      userFrom: {
        searchType: 'all',
        content: '',
        labelId: '',
        userType: '',
        sex: '',
        isPromoter: '',
        country: '',
        payCount: '',
        accessType: '',
        dateLimit: '',
        keywords: '',
        province: '',
        city: '',
        page: 1,
        limit: 20,
        level: '',
        groupId: ''
      },
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      levelList: [],
      labelLists: [],
      groupList: [],
      selectedData: [],
      timeVal: [],
      addresData: [],
      dynamicValidateForm: {
        groupId: []
      },
      loading: false,
      groupIdFrom: [],
      selectionList: [],
      batchName: '',
      uid: 0,
      keyNum: 0,
      address: [],
      multipleSelectionAll: [],
      idKey: 'uid',
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '头像', '姓名', '用户等级', '分组', '推荐人', '手机号', '余额', '积分'],
      columnData: ['ID', '头像', '姓名', '用户等级', '分组', '推荐人', '手机号', '余额', '积分'],
      isIndeterminate: true
    };
  },
  computed: {
    // 是否注销
    isRedFont: function isRedFont() {
      return function (info) {
        if (info.isLogoff) {
          return 'red-fonts';
        } else {
          return '';
        }
      };
    }
  },
  activated: function activated() {
    this.userFrom.keywords = '';
    this.loginType = '0';
    this.getList(1);
  },
  mounted: function mounted() {
    this.getList();
    this.groupLists();
    this.levelLists();
    this.getTagList();
    if (checkPermi(['admin:system:city:list:tree'])) this.getCityList();
  },
  methods: {
    checkPermi: checkPermi,
    setPhone: function setPhone(row) {
      var _this2 = this;
      this.$prompt('', '修改手机号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入修改手机号',
        inputType: 'text',
        inputValue: row.phone,
        inputPlaceholder: '请输入手机号',
        closeOnClickModal: false,
        inputValidator: function inputValidator(value) {
          if (!value) return '请填写手机号';
        }
      }).then(function (_ref) {
        var value = _ref.value;
        updatePhoneApi({
          id: row.uid,
          phone: value
        }).then(function () {
          _this2.$message.success('编辑成功');
          _this2.getList();
        });
      }).catch(function () {
        _this2.$message.info('取消输入');
      });
    },
    // 清除
    clearSpread: function clearSpread(row) {
      var _this3 = this;
      this.$modalSure('解除【' + row.nickname + '】的上级推广人吗').then(function () {
        spreadClearApi(row.uid).then(function (res) {
          _this3.$message.success('清除成功');
          _this3.getList();
        });
      });
    },
    // 批量清空积分（清零选中用户积分）
    clearIntegral: function clearIntegral() {
      var _this4 = this;
      // if (!this.userIds) return this.$message.warning('请选择要清空积分的用户');
      this.$modalSure('确定要清空全部用户的积分吗？此操作不可恢复').then(function () {
        integralBatchClearApi().then(function () {
          _this4.$message.success('清空成功');
          _this4.getList();
        });
      });
    },
    onSubExtension: function onSubExtension(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          updateSpreadApi(_this5.formExtension).then(function (res) {
            _this5.$message.success('设置成功');
            _this5.extensionVisible = false;
            _this5.getList();
          });
        } else {
          return false;
        }
      });
    },
    getTemplateRow: function getTemplateRow(row) {
      this.formExtension.image = row.avatar;
      this.formExtension.spreadUid = row.uid;
    },
    setExtension: function setExtension(row) {
      this.formExtension = {
        image: '',
        spreadUid: '',
        userId: row.uid
      };
      this.extensionVisible = true;
    },
    handleCloseExtension: function handleCloseExtension() {
      this.extensionVisible = false;
    },
    modalPicTap: function modalPicTap() {
      this.userVisible = true;
    },
    resetForm: function resetForm() {
      this.visible = false;
    },
    reset: function reset(formName) {
      this.userFrom = {
        searchType: 'all',
        content: '',
        labelId: '',
        userType: '',
        sex: '',
        isPromoter: '',
        country: '',
        payCount: '',
        accessType: '',
        dateLimit: '',
        keywords: '',
        province: '',
        city: '',
        page: 1,
        limit: 20,
        level: '',
        groupId: ''
      };
      this.address = [];
      this.levelData = [];
      this.groupData = [];
      this.labelData = [];
      this.timeVal = [];
      this.$refs.userSearchInput.clearInput(); // 清空用户搜索输入框
      this.getList();
    },
    // 列表
    getCityList: function () {
      var _getCityList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return logistics.cityListTree();
            case 1:
              res = _context.v;
              //res.forEach((el, index) => {
              //     el.child.forEach((cel, j) => {
              //       delete cel.child
              //     })
              //   })
              this.addresData = res;
              // })
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getCityList() {
        return _getCityList.apply(this, arguments);
      }
      return getCityList;
    }(),
    // 发送文章
    sendNews: function sendNews() {
      if (this.selectionList.length === 0) return this.$message.warning('请先选择用户');
      var _this = this;
      this.$modalArticle(function (row) {}, 'send');
    },
    // 发送优惠劵
    onSend: function onSend() {
      if (this.selectionList.length === 0) return this.$message.warning('请选择要设置的用户');
      var _this = this;
      this.$modalCoupon('send', this.keyNum += 1, [], function (row) {
        _this.formValidate.give_coupon_ids = [];
        _this.couponData = [];
        row.map(function (item) {
          _this.formValidate.give_coupon_ids.push(item.coupon_id);
          _this.couponData.push(item.title);
        });
        _this.selectionList = [];
      }, this.userIds, 'user');
    },
    Close: function Close() {
      this.levelVisible = false;
    },
    // 账户详情
    onDetails: function onDetails(id) {
      this.uid = id;
      this.$refs.userDetailFrom.getUserDetail(id);
      this.$refs.userDetailFrom.dialogUserDetail = true;
    },
    // 等级
    onLevel: function onLevel(id, level) {
      var userLevel = new Object();
      this.levelList.forEach(function (item) {
        if (item.id == level) {
          userLevel.gradeLevel = item.grade;
        }
      });
      userLevel.uid = id;
      userLevel.level = level;
      this.levelInfo = userLevel;
      this.levelVisible = true;
    },
    // 积分余额
    editPoint: function editPoint(id) {
      this.uid = id;
      this.VisiblePoint = true;
    },
    // 积分余额
    submitPointForm: Debounce(function (formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.PointValidateForm.uid = _this6.uid;
          _this6.loadingBtn = true;
          foundsApi(_this6.PointValidateForm).then(function (res) {
            _this6.$message.success('设置成功');
            _this6.loadingBtn = false;
            _this6.handlePointClose();
            _this6.getList();
          }).catch(function () {
            _this6.loadingBtn = false;
          });
        } else {
          return false;
        }
      });
    }),
    // 积分余额
    handlePointClose: function handlePointClose() {
      this.VisiblePoint = false;
      this.PointValidateForm = {
        integralType: 2,
        integralValue: 0,
        moneyType: 2,
        moneyValue: 0,
        uid: ''
      };
    },
    editUser: function editUser(id) {
      this.uid = id;
      this.visible = true;
    },
    submitForm: function submitForm(formName) {
      var _this7 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this7.loading = true;
          _this7.batchName === 'group' ? groupPiApi({
            groupId: _this7.dynamicValidateForm.groupId,
            id: _this7.userIds
          }).then(function (res) {
            _this7.$message.success('设置成功');
            _this7.loading = false;
            _this7.handleClose();
            _this7.getList();
          }).catch(function () {
            _this7.loading = false;
          }) : tagPiApi({
            tagId: _this7.dynamicValidateForm.groupId.join(','),
            id: _this7.userIds
          }).then(function (res) {
            _this7.$message.success('设置成功');
            _this7.loading = false;
            _this7.handleClose();
            _this7.getList();
          }).catch(function () {
            _this7.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    setBatch: function setBatch(name, row) {
      this.batchName = name;
      if (row) {
        this.userIds = row.uid;
        if (this.batchName === 'group') {
          this.dynamicValidateForm.groupId = row.groupId ? Number(row.groupId) : '';
        } else {
          this.dynamicValidateForm.groupId = row.tagId ? row.tagId.split(',').map(Number) : [];
        }
      } else {
        this.dynamicValidateForm.groupId = '';
      }
      if (this.multipleSelectionAll.length === 0 && !row) return this.$message.warning('请选择要设置的用户');
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs['dynamicValidateForm'].resetFields();
    },
    // 全选
    onSelectTab: function onSelectTab(selection) {
      var _this8 = this;
      this.selectionList = selection;
      setTimeout(function () {
        _this8.changePageCoreRecordData();
        var data = [];
        if (_this8.multipleSelectionAll.length) {
          _this8.multipleSelectionAll.map(function (item) {
            data.push(item.uid);
          });
          _this8.userIds = data.join(',');
        }
      }, 50);
    },
    // 搜索
    userSearchs: function userSearchs() {
      this.userFrom.page = 1;
      this.getList();
    },
    // 选择国家
    changeCountry: function changeCountry() {
      if (this.userFrom.country === 'OTHER' || !this.userFrom.country) {
        this.selectedData = [];
        this.userFrom.province = '';
        this.userFrom.city = '';
        this.address = [];
      }
    },
    // 选择地址
    handleChange: function handleChange(value) {
      this.userFrom.province = value[0];
      this.userFrom.city = value[1];
      this.userSearchs();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.userFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.userSearchs();
    },
    // 分组列表
    groupLists: function groupLists() {
      var _this9 = this;
      groupListApi({
        page: 1,
        limit: 9999
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this9.groupList = res.list;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    //标签列表
    getTagList: function getTagList() {
      var _this0 = this;
      tagListApi({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this0.labelLists = res.list;
      });
    },
    // 等级列表
    levelLists: function levelLists() {
      var _this1 = this;
      levelListApi().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this1.levelList = res;
                localStorage.setItem('single-admin-levelKey', JSON.stringify(res));
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // 列表
    getList: function getList(num) {
      var _this10 = this;
      this.listLoading = true;
      this.userFrom.page = num ? num : this.userFrom.page;
      this.userFrom.userType = this.loginType;
      if (this.loginType == 0) this.userFrom.userType = '';
      this.userFrom.level = this.levelData.join(',');
      this.userFrom.groupId = this.groupData.join(',');
      this.userFrom.labelId = this.labelData.join(',');
      userListApi(this.userFrom).then(function (res) {
        _this10.tableData.data = res.list;
        _this10.tableData.total = res.total;
        _this10.$nextTick(function () {
          this.setSelectRow(); // 调用跨页选中方法
        });
        _this10.listLoading = false;
      }).catch(function () {
        _this10.listLoading = false;
      });
      this.checkedCities = this.$cache.local.has('user_stroge') ? this.$cache.local.getJSON('user_stroge') : this.checkedCities;
      this.$set(this, 'card_select_show', false);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    // 记忆选择核心方法
    changePageCoreRecordData: function changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.selectionList;
        return;
      }
      // 总选择里面的key集合
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      var selectIds = [];
      // 获取当前页选中的id
      this.selectionList.forEach(function (row) {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      var noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.data.forEach(function (row) {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(function (uid) {
        if (selectAllIds.indexOf(uid) >= 0) {
          for (var i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == uid) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    pageChange: function pageChange(page) {
      this.changePageCoreRecordData();
      this.userFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.userFrom.limit = val;
      this.getList();
    },
    // 强制注销
    compulsoryCancellation: function compulsoryCancellation(uid) {
      var _this11 = this;
      this.$modalSure('确定要强制注销该用户吗？此操作不可恢复').then(function () {
        userLogoffApi(uid).then(function () {
          _this11.$message.success('强制注销成功');
          _this11.getList();
        }).catch(function () {
          _this11.$message.error('强制注销失败');
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this12 = this;
      this.$modalSure().then(function () {
        productDeleteApi(id).then(function () {
          _this12.$message.success('删除成功');
          _this12.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this13 = this;
      row.isShow ? putOnShellApi(row.id).then(function () {
        _this13.$message.success('上架成功');
        _this13.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : offShellApi(row.id).then(function () {
        _this13.$message.success('下架成功');
        _this13.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    renderHeader: function renderHeader(h) {
      var _this14 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this14.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('user_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};